<ul>
  @if (total_actions_required() > 0) {
    <li>
      <a
        matRipple
        class="menu-link-alert menu-link-alert--danger"
        role="button"
        tabindex="0"
        (click)="openPendingSlackChats($event)"
        (keydown.enter)="openPendingSlackChats($event)"
      >
        <mat-icon>notifications</mat-icon>
        <span>{{ total_actions_required() }} {{ total_actions_required() === 1 ? 'acción pendiente' : 'acciones pendientes' }}</span>
      </a>
    </li>
  }

  @for (company_product_item of company_products_list(); track company_product_item.company_product_id; let first = $first) {
    <li [class.menu-first-section-item]="first" [class.active]="isCompanyProductActive(company_product_item.company_product_id)">
      <a
        matRipple
        role="button"
        tabindex="0"
        (click)="goToCompanyProduct(company_product_item.company_product_id)"
        (keydown.enter)="goToCompanyProduct(company_product_item.company_product_id)"
      >
        <div
          class="company-product-logo"
          [ngStyle]="{ 'background-image': 'url(' + company_product_item.company_product_logo_url + ')' }"
        ></div>
        <span>{{ company_product_item.company_product_name }}</span>
      </a>
    </li>
  }

  <li routerLinkActive="active">
    <a matRipple [routerLink]="['/clients', 'my-company']">
      <mat-icon>business</mat-icon>
      <span>Mi empresa</span>
    </a>
  </li>
  <li routerLinkActive="active">
    <a matRipple [routerLink]="['/clients', 'my-profile']">
      <mat-icon>person</mat-icon>
      <span>Mi perfil</span>
    </a>
  </li>
</ul>
